import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";
import { inject } from "@angular/core";
import { LocalStorageService } from "../services/local-storage.service";
import { StorageKeys } from "../models/storage.interface";
import { CustomLanguageService } from "@app/core/services/language-service";
import { TranslateService } from "@ngx-translate/core";

export const authGaurd: CanActivateFn = (
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) => {

     const authService = inject(AuthService);
     const router = inject(Router);
     const localStorage = inject(LocalStorageService);
     const translation = inject(TranslateService);
     const  languageService: CustomLanguageService = inject(CustomLanguageService);
        if( authService.isAuthorized()){
          return true
        }else {
          const lang = next.queryParams['lang'];
          if (lang) {
            console.log('lang',lang);
            languageService.changeLanguage(lang);
            translation.use(lang);
            localStorage.set(StorageKeys.language, lang);
          }
          localStorage.set(StorageKeys.redirectionURL , state.url);
          return router.navigate(["/auth/sign-in"])
        }

  };

